import { CheckCircle2, XCircle, Info } from 'lucide-react';

const VARIANTS = {
  success: {
    Icon: CheckCircle2,
    iconColor: 'text-green-500',
    button: 'bg-green-500 hover:bg-green-600 shadow-green-500/20',
  },
  error: {
    Icon: XCircle,
    iconColor: 'text-red-500',
    button: 'bg-red-500 hover:bg-red-600 shadow-red-500/20',
  },
  info: {
    Icon: Info,
    iconColor: 'text-[#1E3A8A]',
    button: 'bg-[#1E3A8A] hover:bg-[#172d6e] shadow-[#1E3A8A]/20',
  },
};

const AlertModal = ({ variant = 'info', title, message, onClose, confirmLabel = 'OK' }) => {
  const { Icon, iconColor, button } = VARIANTS[variant] ?? VARIANTS.info;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-xl max-w-sm w-full mx-4 p-6">
        <div className="flex items-start gap-3 mb-3">
          <Icon className={`${iconColor} shrink-0 mt-0.5`} size={24} />
          <h3 className="text-lg font-bold text-gray-800">{title}</h3>
        </div>
        {message && <p className="text-sm text-gray-600 mb-5 whitespace-pre-line">{message}</p>}
        <div className="flex justify-end">
          <button
            onClick={onClose}
            className={`px-4 py-2 rounded-xl text-sm font-semibold text-white shadow-md transition ${button}`}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AlertModal;
